import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinerServiceFormComponent } from './liner-service-form/liner-service-form.component';
import { LinerServiceListComponent } from './liner-service-list/liner-service-list.component';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LinerServiceRoutingModule } from './liner-service-routing.module';



@NgModule({
  declarations: [
    LinerServiceFormComponent,
    LinerServiceListComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    LinerServiceRoutingModule
  ]
})
export class LinerServiceModule { }
